// utils/validators.js
export const isValidEmail = (message) => (value) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ||
  message ||
  "Invalid email address";

export const isValidName = (message) => (value) => {
  if (!value || value.trim() === "") {
    return message || "Name is required";
  }
  if (!/^[a-zA-Z\s]+$/.test(value)) {
    return "Name must contain only alphabetic characters and spaces";
  }
  if (value.length < 2 || value.length > 50) {
    return "Name must be between 2 and 50 characters";
  }
  return true;
};

export const isValidPassword = (message) => (value) => {
  if (value.length < 8 || value.length > 16) {
    return message || "Password must be between 8 and 16 characters";
  }
  if (!/[A-Z]/.test(value)) {
    return "Must contain at least one uppercase letter";
  }
  if (!/[a-z]/.test(value)) {
    return "Must contain at least one lowercase letter";
  }
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value)) {
    return "Must contain at least one special character";
  }
  if (/\s/.test(value)) {
    return "Must not contain spaces";
  }
  if (/(\w)\1\1/.test(value)) {
    return "Must not contain three consecutive identical characters";
  }
  return true;
};

export const isValidPhoneNumber = (message) => (value) => {
  if (!value || value.trim() === "") {
    return message || "Phone number is required";
  }
  if (!/^\d+$/.test(value)) {
    return "Phone number must contain only numbers";
  }
  if (value.length !== 10) {
    return "Phone number must be exactly 10 digits";
  }
  return true;
};

export const isValidCheckbox = (message) => (value) =>
  value === true || message || "You must agree to the terms and conditions";

export const isRequired = (message) => ({
  value: true,
  message: message === "" ? "This field is required" : `${message} is required`,
});

export const maxLength = (max, message) => ({
  value: max,
  message,
});

export const isValidImage = (message) => (value) => {
  const file = value[0]; // Assuming the value is a FileList

  if (!value || value.length === 0) {
    return message || "Image is required";
  }
  if (!file) {
    return message || "No file selected";
  }
  if (file.size === 0) {
    return message || "File is empty";
  }
  return true;
};

export const isValidUsername = (message) => (value) => {
  if (!value || value.trim() === "") {
    return message || "Username is required";
  }
  if (!/^[a-zA-Z0-9_]+$/.test(value)) {
    return message || "Username must contain only alphabets and underscores";
  }
  return true;
};
